import React from "react";

export default function ExpandIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
    >
      <path
        d="M17.1216 7.63206C17.6317 7.63206 18 7.24528 18 6.75471V1.51887C18 0.556603 17.4333 0 16.4701 0H11.2287C10.7282 0 10.341 0.35849 10.341 0.867923C10.341 1.37736 10.7282 1.72642 11.2287 1.72642H12.022L15.3274 1.53773L12.702 4.01886L9.79325 6.92452C9.62326 7.09433 9.52883 7.32075 9.52883 7.57547C9.52883 8.10376 9.93491 8.45282 10.4638 8.45282C10.6904 8.45282 10.9076 8.37734 11.0682 8.20754L13.9674 5.28301L16.4606 2.6698L16.2622 5.96225V6.75471C16.2622 7.25471 16.6307 7.63206 17.1216 7.63206ZM6.76178 18C7.27176 18 7.6495 17.6414 7.6495 17.132C7.6495 16.6226 7.26231 16.2735 6.76178 16.2735H5.97794L2.6726 16.4622L5.28855 13.9811L8.2067 11.0755C8.37669 10.9057 8.46168 10.6792 8.46168 10.4245C8.46168 9.89621 8.06504 9.54716 7.52673 9.54716C7.30009 9.54716 7.09232 9.62263 6.93177 9.79244L4.02307 12.717L1.53934 15.3302L1.72823 12.0377V11.2453C1.72823 10.7453 1.36936 10.3679 0.868832 10.3679C0.36831 10.3679 0 10.7547 0 11.2453V16.4811C0 17.4434 0.557186 18 1.52046 18H6.76178Z"
        fill="white"
      />
    </svg>
  );
}
